export default __webpack_public_path__ + "static/media/technicalDataMapping.79ac603d.svg";